function getOverridePromoDisplayPrompt(path:string, query:string):App.PromoDisplayConfig | undefined {
  // https://luxuryescapes.com/gb/search?destinationName=Mauritius&destinationId=&adults=2&children=none&pages=2
  const overrideDestinationIds = new Map<string, App.PromoDisplayConfig>([
    ['le_43baa6762fa81bb43b39c62553b2970d', {
      headerText: 'Use FLYWITHUS at checkout to get £50 off',
      bodyText: 'Bundle your hotel with a flight to receive £50 off your Dubai dream escape!',
      codeName: 'FLYWITHUS',
      urlPath: '/search',
      promoDisplayId: '',
      displayMode: 'persistence',
      authState: 'logged_in_and_out',
      delayDuration: 1,
      needsOfferCheck: true,
      isTargetedPromo: false,
      useTargetedPromo: false,
      expiresAt: '',
      passOfferCheck: {},
    }], // Dubai
    ['le_2723d092b63885e0d7c260cc007e8b9d', {
      headerText: 'Use FLYWITHUS at checkout to get £50 off',
      bodyText: 'Bundle your hotel with a flight to receive £50 off your Maldives dream escape!',
      codeName: 'FLYWITHUS',
      urlPath: '/search',
      promoDisplayId: '',
      displayMode: 'persistence',
      authState: 'logged_in_and_out',
      delayDuration: 1,
      needsOfferCheck: true,
      isTargetedPromo: false,
      useTargetedPromo: false,
      expiresAt: '',
      passOfferCheck: {},
    }], // Maldives
    ['le_2b44928ae11fb9384c4cf38708677c48', {
      headerText: 'Use FLYWITHUS at checkout to get £50 off',
      bodyText: 'Bundle your hotel with a flight to receive £50 off your Mauritius dream escape!',
      codeName: 'FLYWITHUS',
      urlPath: '/search',
      promoDisplayId: '',
      displayMode: 'persistence',
      authState: 'logged_in_and_out',
      delayDuration: 1,
      needsOfferCheck: true,
      isTargetedPromo: false,
      useTargetedPromo: false,
      expiresAt: '',
      passOfferCheck: {},
    }], // Mauritius
    ['le_5878a7ab84fb43402106c575658472fa', {
      headerText: 'Use FLYWITHUS at checkout to get £50 off',
      bodyText: 'Bundle your hotel with a flight to receive £50 off your Sri Lanka dream escape!',
      codeName: 'FLYWITHUS',
      urlPath: '/search',
      promoDisplayId: '',
      displayMode: 'persistence',
      authState: 'logged_in_and_out',
      delayDuration: 1,
      needsOfferCheck: true,
      isTargetedPromo: false,
      useTargetedPromo: false,
      expiresAt: '',
      passOfferCheck: {},
    }], // Sri Lanka
  ])
  const configMatchId = Array.from(overrideDestinationIds.keys()).find((id) => query?.includes(`destinationId=${id}`))
  const overridePromoDisplayPrompt: App.PromoDisplayConfig | undefined =
    path.startsWith('/gb/search') &&
    configMatchId ? overrideDestinationIds.get(configMatchId) : undefined

  return overridePromoDisplayPrompt
}

export default getOverridePromoDisplayPrompt
